export default __webpack_public_path__ + "static/media/bronze.db695770.svg";